module.exports = ".img-thumbnail-small {\n  border-radius: 0px !important; }\n"